<div class="email-details-component">
  <div class="top-bar flex flex-row px-3 justify-between items-center">
    <h2>Email Details</h2>
  </div>

  <a class="back-wrap" [routerLink]="['/', 'loader-integration-v2']">
    <i class="material-icons">arrow_back</i>
    <span>Back to Loader Integration</span>
  </a>

  <div class="table-wrap">
    <table mat-table [dataSource]="activeDataSource" matSort>
      <ng-container matColumnDef="sender">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Sender</th>
        <td mat-cell *matCellDef="let emailDetails">
          {{ emailDetails.sender }}
        </td>
      </ng-container>

      <ng-container matColumnDef="uploadTime">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Upload Time</th>
        <td mat-cell *matCellDef="let emailDetails">
          {{ emailDetails.uploadTime | date: 'MM/dd/yy hh:mm aa' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="files">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Files</th>
        <td mat-cell *matCellDef="let emailDetails">
          <ng-container *ngIf="emailDetails.files">
            <div class="file-wrap" *ngFor="let file of emailDetails.files" (click)="downloadFile(file.fileName)">
              {{ file.fileName }}
            </div>
          </ng-container>
          <div *ngIf="!emailDetails.files">-</div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let emailDetails; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
